import { ReadOnlyDetails as ReadOnlyDetailsMain } from './ReadOnlyDetails'
import { ReadOnlyItem } from './ReadOnlyItem'

export const ReadOnlyDetails = Object.assign(ReadOnlyDetailsMain, {
  Item: ReadOnlyItem
})
